module.exports = __webpack_public_path__ + "img/box-01.eb5bdc3b.jpg";